<template>
  <section id="login">
    <div style="margin-top:150px; margin-bottom:150px; ">
      <!-- Login Form -->

      <div class="container h-100 d-flex justify-content-center;">
        <div class="login my-auto" style="margin:auto; width:400px">
          <button type="button" aria-label="Close" class="close" @click="volver()">×</button>

          <div style="text-align:center;">
            <h5 style="text-align:center; padding-bottom:15px; padding-top:50px">{{titulo}}</h5>
            <h6 style="text-align:center; padding-bottom:15px;">{{subtitulo}}</h6>

            <form id="claveAleatoria" autocomplete="off" @submit.prevent="ingresoOTP">
              <input
                type="text"
                style="width:200px; margin:auto"
                class="form-control"
                v-model="clave"
                aria-describedby="claveRecibida"
                placeholder="Ingresá la clave recibida"
              />

              <div
                v-if="mensaje"
                style="margin-top:20px"
                class="alert alert-danger"
                role="alert"
              >{{mensaje}}</div>
              <button
                type="button"
                class="btn boton-primario"
                style="margin-top:30px"
                @click="ingresoOTP()"
              >Aceptar</button>
            </form>
            <img
              src="public/images/site/recupero.svg"
              alt="recupero"
              style="padding: 20px; width:200px"
            />
            <p>¿No te llegó?</p>
            <h6 class="olvide-password" @click="enviarCodigo(mail)">Enviar código nuevamente</h6>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "login",

  data() {
    return {
      pass: null,
      passC: null,
      correo: null,
      respuesta: "",
      mensaje: null,
      clave: null,
      procesando: false,
      ingresarOTP: false,
      passwordOK: false,
      titulo: "",
      subtitulo: ""
    };
  },
  props: ["tipo", "mail"],

  computed: {
    ...mapGetters(["categorias", "userLogged", "pathAPI"])
  },

  methods: {
    enviarCodigo(mail) {
      self = this;
      self.errorMessage = "";
      fetch(this.$store.state.pathAPI + "codigo.php", {
        method: "POST",
        body: "&mail=" + mail + "&tipo_codigo=OLVIDO",
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          var loginResponse = response.json();
          loginResponse.then(function(result) {
            if (result.resultado == "ERROR") {
              self.mensaje = result.mensaje;
            } else {
              self.titulo= "Enviamos un nuevo código"
              self.subtitulo="Verificá nuevamente tu correo electrónico"
            }
          });
        } else {
          throw "Error en la llamada Ajax";
        }
      });
    },
    ingresoOTP() {
      var self = this;
      if (!self.clave) {
        self.mensaje = "Debés ingresar el código que te enviamos";
        return;
      }
      if (self.tipo == "Registro") {
        self.usarOTP();
        return;
      }
      if (self.tipo == "Olvido") {
        self.consultaOTP();
        return;
      }
    },
    consultaOTP() {

      fetch(
        this.$store.state.pathAPI +
          "codigo.php?mail=" +
          this.mail +
          "&codigo=" +
          this.clave
      )
        .then(response => response.json())
        .then(data => {
          if (data.resultado == "ERROR") {
            this.mensaje = data.mensaje;
            return;
          }
          this.$router.push({ path: "/NuevaPassword/" + this.clave });

        });
    },

    usarOTP() {
      var self = this;
      var bodyApi;
      bodyApi = "mail=" + self.mail + "&codigo=" + self.clave;
      fetch(self.pathAPI + "codigo.php?" + bodyApi, {
        method: "PUT",
        body: bodyApi,
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          var respuesta;
          respuesta = response.json();
          respuesta.then(function(result) {
            if (result.resultado === "ERROR") {
              self.mensaje = result.mensaje;
            } else {
              if (self.tipo == "Registro") {
                  self.$store.state.userLogged.profile = "PADRE";
                  self.$store.state.userLogged.name = "Hola!";
                  self.$store.state.userLogged.user = self.mail;
                  self.$router.push({ path: "/" });

         
              }
              if (self.tipo == "Olvido") {
                self.$router.push({ path: "/NuevaPassword/" + self.clave });
              }
            }
          });
        } else {
          throw "Error en la llamada Ajax";
        }
      });
    },

    volver() {
      this.$router.push({ path: "/Login/inicio" });
    }
  },
  components: {},

  mounted: function() {
    if (this.tipo == "Registro") {
      this.titulo = "Ya creamos tu usuario";
      this.subtitulo =
        "Ingresá el código que enviamos a tu casilla de correo para confirmar tu cuenta";
    }
    if (this.tipo == "Olvido") {
      this.titulo = "Vamos a recuperar tu contraseña";
      this.subtitulo =
        "Ingresá el código que enviamos a tu casilla de correo para continuar";
    }
  }
};
</script>

<style scoped>
#login {
  background: url("/public/images/site/background-login.svg");
  background-repeat: repeat-x;
  display: table;
  background-size: 1000px;

  width: 100%;
  background-position-y: top;
}

.olvide-password {
  margin: 15px;
  padding: 5px 20px;
  border-radius: 20px !important;
  border: 0px !important;
  align-items: center;
  transition: 0.2s;
  cursor: pointer;
  font-size: 15px;
  font-family: "Patua One", cursive;
  color: rgb(93, 93, 93);
}
.olvide-password:hover {
  transition: 0.2s;
  z-index: 1;
  color: #9546af;
}

.login {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  background-color: #e9ecef;
  border-radius: 15px;
  -webkit-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
}

.close {
  padding: 0px;
  font-size: 40px;
  font-weight: 300;
}
.label {
  margin-bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/startPage/SecretCode.vue